import { Component } from '@angular/core';

@Component({
    selector: 'app-blog-word-to-pdf',
    imports: [],
    templateUrl: './blog-word-to-pdf.component.html',
    styleUrl: './blog-word-to-pdf.component.css'
})
export class BlogWordToPdfComponent {

}
